import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import MetaTags from 'react-meta-tags';
import ReactGA from 'react-ga';
import Footer from '../footer';
import '../assets/css/style.css';
import OurBusiness from './OurBusiness';
import '../css/Popup.css'
import MeetTheTeam from './MeetTheTeam';
import Header from './Headers';
import imagesPath from '../config/imagesPath';
import Swiper from 'react-id-swiper';
import {Helmet} from "react-helmet";


@inject('store')
@observer

class Aboutus extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.store.homeType(false);
        ReactGA.initialize('UA-128486561-1');
        ReactGA.pageview('/aboutus');
    }

    render() {
        const params = {
            loop: true,
            slidesPerView: 4,
            spaceBetween: 15,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            autoplay: {
                delay: 10000,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 5
                },
                480: {
                    slidesPerView: 1,
                    spaceBetween: 5
                },
                767: {
                    slidesPerView: 2,
                    spaceBetween: 15
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 15
                }
            }
        }
        return (
            <div>
                <Helmet>
                    <meta name="title" content="India’s largest lending platform for Electric Vehicle Loans"/>
                    <meta name="description"
                          content="Revfin offers Electric Vehicle loans to independent electric vehicle drivers."/>
                    <meta name="keywords" content="Electric Vehicle loans"/>

                </Helmet>
                <Header/>
                <section className="pdtb-20">
                    <div className="container">
                        <main id="main">
                            <section className="breadcrumbs">
                                <div className="container">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h2>About Us</h2>
                                        <ol>
                                            <li><a href="/">Home</a></li>
                                            <li>About Us</li>
                                        </ol>
                                    </div>
                                </div>
                            </section>
                            <section id="services" className="services">
                                <div className="container" data-aos="fade-up">
                                    <div className="section-titles">
                                        <h3 className="heading_tow">OUR JOURNEY</h3>
                                    </div>
                                </div>
                            </section>
                            <section className="pt20">
                                <div className="container" data-aos="fade-up">
                                    <div className="mgt-40 relative ultab right_app_text d-none d-md-block d-lg-block">

                                        <div className="row">
                                            <div className="col-lg-4 col-md-6 aboutpagehead" data-aos="fade-up"
                                                 data-aos-delay="100">
                                                <h3>2018</h3>
                                                <h4>Birth of Revfin</h4>
                                                <p>Revfin - Incorporation <br/>Acquisition of NBFC Subsidiary - Revfin
                                                    Capital<br/> First Loan Disbursed </p>
                                                <p className="lineborder"></p>
                                            </div>
                                            <div className="col-lg-4 col-md-6 aboutpagehead" data-aos="fade-up"
                                                 data-aos-delay="100">
                                                <h3>2020</h3>
                                                <h4>Green Shoots</h4>
                                                <p>INR 100 MN. Loan Disbursements </p>
                                                <p className="lineborder"></p>
                                            </div>
                                            <div className="col-lg-4 col-md-6 aboutpagehead" data-aos="fade-up"
                                                 data-aos-delay="100">
                                                <h3>2022</h3>
                                                <h4>Growth</h4>
                                                <p>Raised INR 100 Cr in Debt Funding<br/> Partnership with Hero Electric
                                                </p>
                                                <p className="lineborder"></p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12"><img src={imagesPath.img7}
                                                                            className="reduce-image" width="100%"
                                                                            alt=''/></div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-4 col-md-6 aboutpagehead right" data-aos="fade-up"
                                                 data-aos-delay="100">
                                                <p className="lineborder"></p>
                                                <h3>2017</h3>
                                                <h4>Eureka!</h4>
                                                <p>Origin of Idea to form Revfin</p>
                                            </div>
                                            <div className="col-lg-4 col-md-6 aboutpagehead right" data-aos="fade-up"
                                                 data-aos-delay="100">
                                                <p className="lineborder"></p>
                                                <h3>2019</h3>
                                                <h4>Strategic Partnerships</h4>
                                                <p>Psychometrics Partnership with IIT Kharagpur</p>
                                            </div>
                                            <div className="col-lg-4 col-md-6 aboutpagehead right" data-aos="fade-up"
                                                 data-aos-delay="100">
                                                <p className="lineborder"></p>
                                                <h3>2021</h3>
                                                <h4>Recognition</h4>
                                                <p>ISO 270001 Certification<br/> BW Businessworld- Best Fintech Startup
                                                    Award<br/> Great Place to Work Certification </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <div className="d-block d-md-none mysmallSlider">
                                <div className="row">
                                    <div className="col-md-12"><img src={imagesPath.img7} className="reduce-image"
                                                                    width="100%" alt=''/></div>
                                </div>
                                <Swiper {...params} >
                                    <div className="col-lg-4 col-md-6 aboutpage-mobile " data-aos="fade-up"
                                         data-aos-delay="100">
                                        <p className="lineborder"></p>
                                        <h3>2017</h3>
                                        <h4>Eureka!</h4>
                                        <p>Origin of Idea to form Revfin</p>
                                    </div>
                                    <div className="col-lg-4 col-md-6 aboutpage-mobile" data-aos="fade-up"
                                         data-aos-delay="100">
                                        <p className="lineborder"></p>
                                        <h3>2018</h3>
                                        <h4>Birth of Revfin</h4>
                                        <p>Revfin - Incorporation <br/>Acquisition of NBFC Subsidiary - Revfin
                                            Capital<br/> First Loan Disbursed </p>
                                    </div>
                                    <div className="col-lg-4 col-md-6 aboutpage-mobile " data-aos="fade-up"
                                         data-aos-delay="100">
                                        <p className="lineborder"></p>
                                        <h3>2019</h3>
                                        <h4>Strategic Partnerships</h4>
                                        <p>Psychometrics Partnership with IIT Kharagpur</p>
                                    </div>
                                    <div className="col-lg-4 col-md-6 aboutpage-mobile" data-aos="fade-up"
                                         data-aos-delay="100">
                                        <p className="lineborder"></p>
                                        <h3>2020</h3>
                                        <h4>Green Shoots</h4>
                                        <p>INR 100 MN. Loan Disbursements </p>
                                    </div>
                                    <div className="col-lg-4 col-md-6 aboutpage-mobile " data-aos="fade-up"
                                         data-aos-delay="100">
                                        <p className="lineborder"></p>
                                        <h3>2021</h3>
                                        <h4>Recognition</h4>
                                        <p>ISO 270001 Certification<br/> BW Businessworld- Best Fintech Startup
                                            Award<br/> Great Place to Work Certification </p>
                                    </div>
                                    <div className="col-lg-4 col-md-6 aboutpage-mobile" data-aos="fade-up"
                                         data-aos-delay="100">
                                        <p className="lineborder"></p>
                                        <h3>2022</h3>
                                        <h4>Growth</h4>
                                        <p>Raised INR 100 Cr in Debt Funding<br/> Partnership with Hero Electric</p>
                                    </div>
                                </Swiper>
                            </div>
                            <section className="pt20 section-bg">
                                <div className="row" data-aos="fade-up">
                                    <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12 destop-view-about-us-content">
                                        <p className='content-info' style={
                                            {
                                                textAlign: 'justify'
                                            }
                                        } data-aos="fade-up">At Revfin, we are building India’s largest lending company.
                                            Through our award winning and
                                            innovative digital platform, we provide loans to people at the bottom of the
                                            pyramid.
                                            Our typical customer lives in Tier 2 or 3 town, has no credit history, very
                                            low level of education
                                            and no banking transactions. We underwrite loans using revolutionary
                                            techniques like
                                            psychometrics, biometrics and gamification. The entire loan application
                                            journey is delivered
                                            digitally through an App.<br/><br/>
                                            We have a clear focus on financing commercial electric vehicles for
                                            individual drivers, helping
                                            in mass scale adoption of electric vehicles. Drivers financed by us use
                                            their vehicles for
                                            passenger transportation, e-commerce and cargo deliveries. All vehicles
                                            financed by us have
                                            telematics which help drivers track and improve their productivity while
                                            keeping their vehicles
                                            secure.<br/>
                                            We partner with manufacturers, dealers, fleet operators and e-commerce
                                            companies to
                                            acquire customers, providing point of sale finance. <br/><br/>
                                            We provide loans through our own NBFC as well as through multiple lending
                                            partners. </p>
                                    </div>

                                    <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 padding-top-revfin" style={{
                                        height: '320px'
                                    }}>
                                        <iframe width="560" height="320px" src={imagesPath.video2}
                                                title="YouTube video player" frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen className="iframe-video"/>

                                    </div>


                                </div>
                            </section>
                        </main>
                    </div>
                    <section id="counts" className="counts graybgcolor section-bg our-business-section">
                        <OurBusiness/>
                    </section>
                    <section id="about" className="about section-bg">
                        <div className="container" data-aos="fade-up">
                            <div className="row pb60">
                                <div className="col-lg-6 pt-4 pt-lg-0 content " data-aos="fade-up" data-aos-delay="100">
                                    <h3 style={{
                                        display: 'flex',
                                        justifyContent: 'center'
                                    }}>OUR VISION</h3>
                                    <p className="blue-color content-info" style={{
                                        display: 'flex',
                                        justifyContent: 'center'
                                    }}>To build India’s largest lending company </p>
                                </div>
                                <div className="col-lg-6 pt-4 pt-lg-0 content" data-aos="fade-right"
                                     data-aos-delay="100">
                                    <h3 style={{
                                        display: 'flex',
                                        justifyContent: 'center'
                                    }}>OUR MISSION</h3>
                                    <p className="blue-color content-info" style={{
                                        display: 'flex',
                                        justifyContent: 'center'
                                    }}> To provide loans digitally to financially underserved high growth segments with
                                        scale
                                        and low NPAs using innovative underwriting techniques like Psychometrics,
                                        Biometrics and
                                        Gamification.</p>
                                </div>
                            </div>
                        </div>
                        <div className="gray-bgcolor"></div>
                        <div className="blue-bgcolor"></div>
                    </section>
                    <MeetTheTeam/>
                    <div>
                        <section id="services" className="services">
                            <div className="container" data-aos="fade-up">
                                <div className="section-titles">
                                    <h3 className="heading_tow">AWARDS AND CERTIFICATIONS</h3>
                                </div>
                            </div>
                        </section>
                        <section className="slider_loan">
                            <div className="container" data-aos="zoom-in" data-aos-delay="100">
                                <div className="cara_slider newAdditon">
                                    <Swiper {...params} >
                                        {
                                            imagesPath.memberCertificate.map((ele, index) => (
                                                <div className="swiper-slide" data-aos="zoom-in" data-aos-delay="300"
                                                     key={index}>
                                                    <div className="slider_pannel">
                                                        <div className="swiper-slide"><img src={ele.img} alt=''
                                                                                           className='member-certification-slider'/>
                                                        </div>
                                                    </div>

                                                </div>
                                            ))
                                        }
                                    </Swiper>
                                </div>
                            </div>
                        </section>
                    </div>
                </section>
                <Footer/>
            </div>
        )
    }
}


export default Aboutus;



// WEBPACK FOOTER //
// ./src/components/aboutus.js